import MProvider from './provider.menu'
import MPartner from './partner.menu'
import MClient from './client.menu'

export const getSidebarMenus = user => {
  switch (user.organization_type) {
    case 'provider': {
      return MProvider
    }
    case 'partner': {
      return MPartner
    }
    case 'client': {
      return MClient
    }
    default: {
      return []
    }
  }
}
